import {Component} from '@angular/core';
import {Router} from "@angular/router";

import {AppService} from '@api';
import {SistemaService} from '@servicios/Sistema.Service';
import {OpcionMenu} from '@modelo/OpcionMenu.model';
import {TipoIconoEnum} from '@enumeraciones/Enumeraciones.enum';

@Component(
    {
        selector: 'home',
        templateUrl: './Home.template.html',
        styleUrls: ['./Home.scss'],
    })

export class HomeComponent {
    public TipoIconoEnum = TipoIconoEnum;

    constructor(private appService: AppService, private router: Router, public sistemaService: SistemaService) {
    }

    ngOnInit() {
    }

    IrPagina(opcion: OpcionMenu) {
        this.router.navigateByUrl(opcion.Ruta);
    }

}
